module.exports = __webpack_public_path__ + "static/media/Anix Developments Inc. - Compliance Order - March 8, 2023.846fd40a.pdf";